// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","registrationForm":"qg7U53auusSBtwHsECt6A","registrationFormError":"_2Fjx5zFS_kI9i69KKZS2AG","couponCode":"_2hcqnykqdA1rCRELIMy8gw"};